import { CaretLeft } from '@phosphor-icons/react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

type HeaderBackButtonProps = {
  url?: string | null;
};

export function HeaderBackButton({ url = null }: HeaderBackButtonProps) {
  const navigate = useNavigate();

  return (
    <Button
      icon={<CaretLeft size={16} weight="bold" />}
      onClick={() => (url ? navigate(url) : navigate(-1))}
      aria-label="Back"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        padding: 0,
        flexShrink: 0,
      }}
    />
  );
}
